import { Component, effect, input, output } from '@angular/core';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrl: './card.component.scss',
})
export class CardComponent {
  readonly collapsible = input(false);
  readonly startCollapsed = input(true);
  readonly toggled = output<boolean>();

  collapsed = true;

  constructor() {
    effect(() => {
      this.collapsed = this.startCollapsed();
    });
  }

  toggleCollapse(): void {
    this.collapsed = !this.collapsed;
    this.toggled.emit(this.collapsed);
  }

  forceCollapse(): void {
    this.collapsed = true;
  }
}
